import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=031579d7&scoped=true"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"
import style0 from "./SvgIcon.vue?vue&type=style&index=0&id=031579d7&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031579d7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('031579d7')) {
      api.createRecord('031579d7', component.options)
    } else {
      api.reload('031579d7', component.options)
    }
    module.hot.accept("./SvgIcon.vue?vue&type=template&id=031579d7&scoped=true", function () {
      api.rerender('031579d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/SvgIcon.vue"
export default component.exports